export enum AlertConstants {
  SUCCESS = "ALERT_SUCCESS",
  ERROR = "ALERT_ERROR",
  CLEAR = "ALERT_CLEAR",
}
